import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { SessionItemRow } from '../../providers/sessionItems-provider';
import { HasPendingChangesGuard } from '../../../common/guards/has-pending-changes';
import { EditableBlockInterface } from '../../editable-block-interface';
import { SessionBlocEditComponent } from '../session-bloc/session-bloc-edit';
import { SessionCommentEditComponent } from './session-comment-edit';
import { TranslateModule } from "@ngx-translate/core";
import { DefaultPipe } from "../../../common/pipes/default";
import { NgIf } from "@angular/common";
import { MatIconButton } from "@angular/material/button";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";
import { FlexLayoutModule } from "@angular/flex-layout";

@Component({
  selector: 'session-comment',
  providers: [],
  standalone: true,
  styleUrls: ['./session-comment.scss'],
  imports: [
    TranslateModule,
    DefaultPipe,
    NgIf,
    MatIconButton,
    MatMenuItem,
    MatMenuTrigger,
    MatTooltip,
    MatMenu,
    MatIcon,
    FlexLayoutModule
  ],
  templateUrl: './session-comment.html'
})
export class SessionCommentComponent implements EditableBlockInterface {
    @Input() public data: SessionItemRow = {} as SessionItemRow;
    @Input() public isEditable = true;
    @Input() public itsTheFirst = false;
    @Input() public itsTheLast = false;
    @Input() public parentIndex: number | undefined;
    @Output('onDelete') public onDelete: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
    @Output('onDuplicate') public onDuplicate: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
    @Output('onMoveUp') public onMoveUp: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
    @Output('onMoveDown') public onMoveDown: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
    @Output() public onChanged: EventEmitter<any> = new EventEmitter<any>();

    @HostListener('window:beforeunload')
    doSomething() {
        return !this._changesGuard.hasChanges();
    }
    public isSelected = false;

    constructor(
        private _changesGuard: HasPendingChangesGuard,
    ) {
    }

    public editComponent(): any {
        return SessionCommentEditComponent;
    }

    public toggleSelected(bool: boolean): void {
        this.isSelected = bool;
    }

    public duplicate(toDuplicate: SessionItemRow): void {
        this.onDuplicate.emit(toDuplicate);
    }

    public delete(toDelete: SessionItemRow): void {
        this.onDelete.emit(toDelete);
    }

    public onCommentChange(event: EventEmitter<any>): void {
        this.onChanged.emit();
    }

    public moveup(toMove: SessionItemRow): void {
        toMove.parentIndex = this.parentIndex;
        this.onMoveUp.emit(toMove);
    }

    public movedown(toMove: SessionItemRow): void {
        toMove.parentIndex = this.parentIndex;
        this.onMoveDown.emit(toMove);
    }
}
